import { persistSliceReducer, RESET_STATE } from "@overmap-ai/core"
import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

import { APP_DATA_DB_NAME } from "../constants"

export interface SessionSliceState {
	/**
	 * Set when the API answers a request with "you are not authenticated", and read by the dialog that offers the user
	 * a way back in. It is deliberately not the same thing as `isLoggedIn`: that is cleared as part of signing out,
	 * while this means the app believed it was signed in and turned out to be wrong.
	 */
	sessionExpired: boolean
}

const initialState: SessionSliceState = {
	sessionExpired: false,
}

export const sessionSlice = createSlice({
	name: "session",
	initialState,
	extraReducers: (builder) => builder.addCase(RESET_STATE, (state) => Object.assign(state, initialState)),
	reducers: {
		setSessionExpired: (state, action: PayloadAction<boolean>) => {
			state.sessionExpired = action.payload
		},
	},
})

export const { setSessionExpired } = sessionSlice.actions

export const sessionReducer = persistSliceReducer(sessionSlice, APP_DATA_DB_NAME)
